// @ts-nocheck
import {
  Injectable, Output, EventEmitter, Inject,
} from '@angular/core';
import { STORAGE, StorageService } from './storage.service';

@Injectable({
  providedIn: 'root',
})
export class CookieConsentService {
  static CONSENT_KEY = 'proportunity_cookie_consent';

  @Output() event: EventEmitter<boolean> = new EventEmitter();

  get accepted(): boolean {
    return !!this.storage.get(STORAGE.COOKIE, CookieConsentService.CONSENT_KEY);
  }

  constructor(
    @Inject('config') private config,
    private storage: StorageService,
  ) { }

  /**
   *
   */
  public accept(): void {
    this.storage.set(STORAGE.COOKIE, CookieConsentService.CONSENT_KEY, '1', {
      expires: 30,
      secure: this.config.production,
      path: '/',
      domain: this.config.environment === 'local'
        ? 'proportunity.local'
        : '.proportunity.com',
    });

    this.event.emit(true);
  }
}
